import { UsersIcon } from 'lucide-react';
import { founder } from '../../data/content';
import { isOwnerId } from '../../core/rules/salonDays';
import { choiceState } from '../../ui/styles';
import type { BookingControl } from './useBooking';
const legend = 'type-name text-ink';

/**
 * "Bij wie wil je komen?" — alleen in een gedeelde salon en als meer dan één persoon deze
 * behandeling doet. "Maakt niet uit" laat alle salondagen zien (eerst beschikbaar); een persoon
 * kiezen laat alleen haar dagen zien. Een lopende kuur of vaste behandelaar staat al aan.
 */
export function PerformerChoice({
  b
}: {
  b: BookingControl;
}) {
  if (b.performers.length === 0) return null;
  const chosen = b.performers.find(s => s.id === b.staffChoice);
  const options = [{
    id: null,
    name: 'Maakt niet uit',
    line: 'Eerst beschikbaar, op elke salondag',
    photo: null as string | null
  }, ...b.performers.map(s => ({
    id: s.id as string | null,
    name: s.name,
    line: s.intro ?? '',
    photo: s.photo ?? (isOwnerId(s.id) ? founder.portrait : null)
  }))];
  return <fieldset data-id="element-8726" data-mp="2ox9au50qctvi">
      <legend className={legend} data-id="element-8727" data-mp="2owrdt668ubmj">Bij wie wil je komen?</legend>
      {b.staffFromHistory && <p className="mt-1 text-[14px] text-muted" data-id="element-8728" data-mp="2kwgwwygwy0sw">We kozen alvast wie je de vorige keer behandelde. Wijzigen kan altijd.</p>}
      <div role="radiogroup" aria-label="Bij wie wil je komen?" className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-8729" data-mp="2yskoek0ejv1o">
        {options.map(o => {
        const on = b.staffChoice === o.id;
        return <button key={o.id ?? 'iedereen'} type="button" role="radio" aria-checked={on} onClick={() => b.setStaffChoice(o.id)} className={`flex min-h-[4.5rem] items-center gap-3 rounded-sm px-3 py-3 text-left ${choiceState(on)}`} data-id="element-8730" data-mp="37szcts8nxq9e">
              {o.photo ? <img src={o.photo} alt="" className="h-12 w-12 shrink-0 rounded-full bg-sand object-cover" loading="lazy" data-id="element-8731" data-mp="3rk4f0ozbwbdp" /> : <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-sand text-ink" aria-hidden="true" data-id="element-8732" data-mp="3tng4z5r2dtyw">
                  <UsersIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-8733" data-mp="2gdao5fxj7kg" />
                </span>}
              <span className="min-w-0" data-id="element-8734" data-mp="7f6ro7ufdgpd">
                <span className="block text-[15px]" data-id="element-8735" data-mp="7e57ndvfljvi">{o.name}</span>
                {o.line && <span className="mt-0.5 block text-[13px] leading-snug opacity-75" data-id="element-8736" data-mp="c8j31ga3fr06">{o.line}</span>}
              </span>
            </button>;
      })}
      </div>
      {chosen?.bio && <p className="mt-3 whitespace-pre-line text-[14px] leading-relaxed text-muted" data-id="element-8737" data-mp="l61up3i8t3l1">
          <span className="text-ink" data-id="element-8738" data-mp="q80wi8yc3sfv">Over {chosen.name}: </span>
          {chosen.bio}
        </p>}
      {b.courseStaffWarning && <p className="mt-3 rounded-sm bg-sand px-3 py-2 text-[13px] text-ink" data-id="element-8739" data-mp="v3pz6l5nhpge">{b.courseStaffWarning}</p>}
    </fieldset>;
}